import { render, staticRenderFns } from "./field_item_add.vue?vue&type=template&id=4ac41414&scoped=true"
import script from "./field_item_add.vue?vue&type=script&lang=js"
export * from "./field_item_add.vue?vue&type=script&lang=js"
import style0 from "./field_item_add.vue?vue&type=style&index=0&id=4ac41414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac41414",
  null
  
)

export default component.exports